import { PostAttendeeActionsActionTypes } from "./types";
var initialState = {};
export function postAttendeeActionsReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case PostAttendeeActionsActionTypes.GET_LOOKUPS:
            return Object.assign({}, state, {
                lookups: Object.assign({}, state.lookups, {
                    status: Object.assign({}, (_a = state.lookups) === null || _a === void 0 ? void 0 : _a.status, {
                        isLoading: true,
                        loadingId: action.payload.lookupId,
                    }),
                }),
            });
        case PostAttendeeActionsActionTypes.SET_LOOKUPS:
            return Object.assign({}, state, {
                lookups: Object.assign({}, state.lookups, {
                    status: Object.assign({}, (_b = state.lookups) === null || _b === void 0 ? void 0 : _b.status, {
                        isLoading: false,
                        isLoaded: true,
                    }),
                    myEvents: action.payload,
                }),
            });
        case PostAttendeeActionsActionTypes.GET_ATTENDEES:
            return Object.assign({}, state, {
                attendees: Object.assign({}, state.attendees, {
                    status: Object.assign({}, (_c = state.attendees) === null || _c === void 0 ? void 0 : _c.status, {
                        isLoading: true,
                        loadingId: action.payload.eventNumber,
                    }),
                }),
            });
        case PostAttendeeActionsActionTypes.SET_ATTENDEES:
            return Object.assign({}, state, {
                attendees: Object.assign({}, state.attendees, {
                    status: Object.assign({}, (_d = state.attendees) === null || _d === void 0 ? void 0 : _d.status, {
                        isLoading: false,
                        isLoaded: true,
                    }),
                    myAttendees: action.payload,
                }),
            });
        case PostAttendeeActionsActionTypes.GET_ORDERS:
            return Object.assign({}, state, {
                orders: Object.assign({}, state.orders, {
                    status: Object.assign({}, (_e = state.orders) === null || _e === void 0 ? void 0 : _e.status, {
                        isLoading: true,
                        loadingId: action.payload.eventNumber,
                    }),
                }),
            });
        case PostAttendeeActionsActionTypes.SET_ORDERS:
            return Object.assign({}, state, {
                orders: Object.assign({}, state.orders, {
                    status: Object.assign({}, (_f = state.orders) === null || _f === void 0 ? void 0 : _f.status, {
                        isLoading: false,
                        isLoaded: true,
                    }),
                    myOrders: action.payload,
                }),
            });
        case PostAttendeeActionsActionTypes.GET_GROUP:
            return Object.assign({}, state, {
                groups: Object.assign({}, state.groups, {
                    status: Object.assign({}, (_g = state.groups) === null || _g === void 0 ? void 0 : _g.status, {
                        isLoading: true,
                        loadingId: action.payload.eventNumber,
                    }),
                }),
            });
        case PostAttendeeActionsActionTypes.SET_GROUP:
            return Object.assign({}, state, {
                groups: Object.assign({}, state.groups, {
                    status: Object.assign({}, (_h = state.groups) === null || _h === void 0 ? void 0 : _h.status, {
                        isLoading: false,
                        isLoaded: true,
                    }),
                    myGroup: action.payload,
                }),
            });
        case PostAttendeeActionsActionTypes.SET_PAYMENT_REQUIRED_PAYLOAD:
            return Object.assign({}, state, {
                paymentRequiredPayload: action.payload,
            });
        default:
            return state;
    }
}
